import React from "react";
import { useActions } from "../../hooks";
import { AudioPlayer, Props } from "./AudioPlayer";

export default (props: Omit<Props, "stopAudio">) => {
  const { stopAudio } = useActions();

  return <AudioPlayer {...props} stopAudio={stopAudio} />;
};
